<template>
    <v-dialog v-model="modalProp" width="500">
        <v-card>
            <v-card-title class="headline grey lighten-2">
                Change Password
                <v-spacer />
                <v-btn
                    icon
                    @click="modalProp = false"
                >
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="mt-6">
                <h3 :class="text_color">
                    {{ status || "&nbsp;" }}
                </h3>

                <v-form
                    ref="form"
                    v-model="valid"
                    @submit.prevent="changePass"
                >
                    <v-text-field
                        v-model="currpass"
                        label="Current password"
                        color="green accent-4"
                        :append-icon="showPass ? mdiEye: mdiEyeOff"
                        :type="showPass ? 'text' : 'password'"
                        :rules="rules.passRules"
                        autocomplete="nope"
                        :prepend-inner-icon="mdiLock"
                        @click:append="showPass = !showPass"
                    />
                    <v-text-field
                        v-model="newpass"
                        :append-icon="showNewPass ? mdiEye : mdiEyeOff"
                        :type="showNewPass ? 'text' : 'password'"
                        label="Enter your new password"
                        hint="At least 8 characters and contains an uppercase, lowercase and number"
                        :rules="rules.passRules"
                        color="green accent-4"
                        :prepend-inner-icon="mdiLockOutline"
                        autocomplete="nope"
                        @click:append="showNewPass = !showNewPass"
                    />
                    <v-text-field
                        v-model="retypedNewpass"
                        :append-icon="showRetypePass ? mdiEye : mdiEyeOff"
                        :type="showRetypePass ? 'text' : 'password'"
                        label="Re-type your password"
                        :rules="rules.passRules.concat([(newpass === retypedNewpass) || 'Password does not match.'])"
                        color="green accent-4"
                        :prepend-inner-icon="mdiLockOutline"
                        autocomplete="nope"
                        @click:append="showRetypePass = !showRetypePass"
                    />
                    <v-divider />

                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            type="submit"
                            :loading="isLoading"
                            :disabled="!valid || isDisabled"
                            color="green"
                            text
                        >
                            Update
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose, mdiEye, mdiEyeOff, mdiLock, mdiLockOutline } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
export default {
    props: ['editPass'],
    data: () => ({
        mdiClose, mdiEye, mdiEyeOff, mdiLock, mdiLockOutline,
        currpass: '',
        retypedNewpass: '',
        newpass: '',
        showPass: false,
        showRetypePass: false,
        showNewPass: false,
        status: '',
        changed: '',
        rules: {
            passRules: [
                (validation) => !!validation || 'Password is required',
                (validation) =>
                    // validate the new regex here https://regexr.com/7rr6e
                    // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(validation) ||
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()-_=+{};:,.<>?/\\|\[\]~]{8,}$/.test(validation) ||
                    'Must contain uppercase, lowercase and number and at least 8 characters '
            ]
        },
        text_color: 'green--text',
        isLoading: false,
        isDisabled: false,
        valid: true
    }),
    computed: {
        ...mapGetters(['succChangePass', 'errChangePass']),
        modalProp: {
            get() {
                return this.editPass
            },
            set(val) {
                this.$emit('showDlgEditPass', val)
            }
        }
    },
    watch: {
        newpass() {
            this.status = ''
        },
        currpass() {
            this.status = ''
        },
        retypedNewpass() {
            this.status = ''
        },
        errChangePass(newVal) {
            if (newVal) {
                this.status = newVal
                this.text_color = 'red--text'
            } else {
                this.status = ''
            }
        },
        succChangePass(newVal) {
            if (newVal) {
                this.status = newVal
                this.text_color = 'green--text'
            } else {
                this.status = ''
            }
        }
    },
    methods: {
        ...mapActions(['manageAccountPass']),
        changePass() {
            this.status = ''
            if (this.$refs.form.validate()) {
                if(this.newpass != '' && /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()-_=+{};:,.<>?/\\|\[\]~]{8,}$/.test(this.newpass)){
                    if (this.newpass === this.retypedNewpass) {
                        this.isLoading = true
                        this.disabled = true
                        this.manageAccountPass({
                            MEMBN: this.$cookies.get('usermembn'),
                            CURRPASS: this.currpass,
                            NEW_PASS: this.newpass
                        }).then(() => {
                            this.isLoading = false
                            this.disabled = false
                        })
                    } else {
                        this.status = 'Check your password. Password do not match.'
                        this.text_color = 'red--text'
                    }
                } else {
                    this.status = 'Invalid input.'
                    this.text_color = 'red--text'
                }
            }
        }
    }
}
</script>

<style></style>
